import { AsyncReturnType } from "type-fest";

import { CampaignService } from "@/services";
import { UseQuerySimpleOptions, useQuery } from "@/services/hooks";

type QueryFnData = AsyncReturnType<typeof CampaignService.getCategories>;
type Error = unknown;

const queryKey = () => ["campaigns", "categories"];

export const useCategories = <TData = QueryFnData>(
  options?: UseQuerySimpleOptions<QueryFnData, Error, TData>
) => {
  const result = useQuery<QueryFnData, Error, TData>(
    queryKey(),
    () => CampaignService.getCategories(),
    options
  );

  return result;
};

useCategories.queryKey = queryKey;
